export const FETCH_SERVICE_STATUS_REQUEST = 'FETCH_SERVICE_STATUS_REQUEST';
export const FETCH_SERVICE_STATUS_FAILURE = 'FETCH_SERVICE_STATUS_FAILURE';
export const FETCH_SERVICE_STATUS_SUCCESS = 'FETCH_SERVICE_STATUS_SUCCESS';